module.exports = __webpack_public_path__ + "static/media/car-color-blue.bf8e073b.svg";